module.exports = "/images/ce-mark-factory.svg?0aba81e7860f49fb094f790106acc97e";